export default "__VITE_ASSET__BBGQ4TnM__"